import { render } from "./JournalVoucher.vue?vue&type=template&id=70e029e4&scoped=true&ts=true"
import script from "./JournalVoucher.vue?vue&type=script&lang=ts"
export * from "./JournalVoucher.vue?vue&type=script&lang=ts"

import "./JournalVoucher.vue?vue&type=style&index=0&id=70e029e4&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e029e4"]])

export default __exports__